import { sharedTranslations } from 'components/shared/translations'

const campaignTypeTranslation = (isCompetition) =>
  isCompetition ? sharedTranslations.competition : sharedTranslations.campaign

export { campaignTypeTranslation }
